import { methods } from '@/utils/methods'

// 施設検索クエリ情報

const state = () => ({
  // 施設検索クエリ情報
  query: {
    area: '',
    prefecture: '',
    city: '',
    keyword: '',
    eventType: [],
    service: [],
    facilityType: [],
    order: '',
    page: '',
    eventTag: '',
    station: '',
    line: ''
  },
  // 「さらに詳しく絞り込む」検索メニューの開閉状態
  openSearchFilter: false
})

const getters = {
  query: (state) => state.query,
  openSearchFilter: (state) => state.openSearchFilter
}

const mutations = {
  query(state, query) {
    // 更新する分だけをqueryで指定する
    state.query = { ...state.query, ...query }
  },
  openSearchFilter(state, openSearchFilter) {
    state.openSearchFilter = openSearchFilter
  }
}

const actions = {
  // 施設検索クエリ情報セット
  query({ commit }, query) {
    commit('query', query)
  },
  // 施設検索クエリ情報をリセット
  reset({ dispatch }) {
    dispatch('query', {
      area: '',
      prefecture: '',
      city: '',
      keyword: '',
      eventType: [],
      service: [],
      facilityType: [],
      order: '',
      page: '',
      eventTag: '',
      station: '',
      line: ''
    })
  },
  // URLパラメータから、施設検索クエリ情報に戻す
  restore({ dispatch }, pathMatch) {
    const params = pathMatch.split('/').map(function(p) {
      // 英数字をキーにしてハイフンで分割
      const m = p.match(/^([a-zA-Z0-9]+)-(.*)/)
      let key = p
      let value = ''
      if (m) {
        key = m[1]
        value = m[2]
        // スラッシュのエンコードを戻す
        value = value.replace(/(%252F|%2F)/g, '/')
      }
      return [key, value]
    })

    const queryKeys = {
      ar: 'area',
      pr: 'prefecture',
      ci: 'city',
      q: 'keyword',
      sc: 'eventType',
      sv: 'service',
      ft: 'facilityType',
      so: 'order',
      p: 'page',
      et: 'eventTag',
      st: 'station',
      li: 'line'
    }
    const query = {}
    params.forEach((param) => {
      if (queryKeys[param[0]]) {
        if (queryKeys[param[0]] === 'eventType') {
          query[queryKeys[param[0]]] = methods.sortEventType(param[1])
        } else if (queryKeys[param[0]] === 'service') {
          query[queryKeys[param[0]]] = methods.sortService(param[1])
        } else if (queryKeys[param[0]] === 'facilityType') {
          query[queryKeys[param[0]]] = methods.sortFacilityType(param[1])
        } else {
          query[queryKeys[param[0]]] = param[1]
        }
      }
    })
    dispatch('reset')
    dispatch('query', query)
  },
  // 「さらに詳しく絞り込む」検索メニューの開閉状態をセット
  openSearchFilter({ commit }, openSearchFilter) {
    commit('openSearchFilter', openSearchFilter)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
